import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { QuestionType } from '../../enums/question-type.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'questionType',
  standalone: false
})
export class QuestionTypePipe implements PipeTransform {
  public transform(value: QuestionType): string {
    return getQuestionType(value);
  }
}

export function getQuestionType(value: QuestionType): string {
  switch (value) {
    case QuestionType.Input:
      return 'Comment Box';
    case QuestionType.Score:
      return 'Score';
    case QuestionType.Radio:
      return 'Radio';
    default:
      throw new Error(`Unsupported value for QuestionType: ${value}.`);
  }
}

export function getQuestionTypeList(): IdName[] {
  return enumToList(QuestionType, getQuestionType);
}
